// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Whale Panel Styles - CSS Module */
.gRuPDBUpUrioFlEOs1Gu {
  /* Styles applied via className in component */
}

.C77jVD2QYY9TfHengCZ2 {
  /* Title styles */
}

.wE36H10gHANnM0ixJEMp {
  /* Net flow styles */
}

.Opnlt5X2CdrYY4_UwM8U {
  /* Positive net flow */
}

.gMKcdV6SoYWzcRDpUNZs {
  /* Negative net flow */
}

.RSXH1GmTMIUSMeNpOq7P {
  width: 100%;
  border-collapse: collapse;
}

.RSXH1GmTMIUSMeNpOq7P th {
  padding: 8px;
  text-align: left;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  font-weight: 600;
  border-bottom: 1px solid var(--vnsc-border);
}

.RSXH1GmTMIUSMeNpOq7P td {
  padding: 8px;
  border-bottom: 1px solid var(--vnsc-border);
}

.AKzQBFmf59O5UsRZFLA0 {
  font-weight: 500;
  color: var(--vnsc-text-primary);
}

.tAD8kPh5vSV0nn5uLQMn {
  color: #089981;
  font-weight: 600;
  text-align: right;
}

._M02zKuCHVxFq0StpMzj {
  color: #f23645;
  font-weight: 600;
  text-align: right;
}

@media (max-width: 480px) {
  .gRuPDBUpUrioFlEOs1Gu {
    /* Mobile adjustments */
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/whale-panel.module.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Whale Panel Styles - CSS Module */\r\n.panel {\r\n  /* Styles applied via className in component */\r\n}\r\n\r\n.title {\r\n  /* Title styles */\r\n}\r\n\r\n.net {\r\n  /* Net flow styles */\r\n}\r\n\r\n.netPositive {\r\n  /* Positive net flow */\r\n}\r\n\r\n.netNegative {\r\n  /* Negative net flow */\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.table th {\r\n  padding: 8px;\r\n  text-align: left;\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  border-bottom: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.table td {\r\n  padding: 8px;\r\n  border-bottom: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.rowLabel {\r\n  font-weight: 500;\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.buy {\r\n  color: #089981;\r\n  font-weight: 600;\r\n  text-align: right;\r\n}\r\n\r\n.sell {\r\n  color: #f23645;\r\n  font-weight: 600;\r\n  text-align: right;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .panel {\r\n    /* Mobile adjustments */\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `gRuPDBUpUrioFlEOs1Gu`,
	"title": `C77jVD2QYY9TfHengCZ2`,
	"net": `wE36H10gHANnM0ixJEMp`,
	"netPositive": `Opnlt5X2CdrYY4_UwM8U`,
	"netNegative": `gMKcdV6SoYWzcRDpUNZs`,
	"table": `RSXH1GmTMIUSMeNpOq7P`,
	"rowLabel": `AKzQBFmf59O5UsRZFLA0`,
	"buy": `tAD8kPh5vSV0nn5uLQMn`,
	"sell": `_M02zKuCHVxFq0StpMzj`
};
export default ___CSS_LOADER_EXPORT___;
